import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const InquiryPage = lazy(() => import('../pages/inquiry/page'));
const CheckoutSuccess = lazy(() => import('../pages/checkout/success'));
const CheckoutCancel = lazy(() => import('../pages/checkout/cancel'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const InstallPage = lazy(() => import('../pages/install/page'));
const BlogIndex = lazy(() => import('../pages/blog/index'));
const BlogDeployOpenClaw = lazy(() => import('../pages/blog/deploy-openclaw-uk-clients'));
const BlogGitwixPartnership = lazy(() => import('../pages/blog/gitwix-openclaw-partnership'));
const BlogWhatsAppIntegration = lazy(() => import('../pages/blog/openclaw-whatsapp-integration-uk'));
const BlogGDPRCompliant = lazy(() => import('../pages/blog/gdpr-compliant-ai-agents-openclaw'));
const BlogSlackIntegration = lazy(() => import('../pages/blog/openclaw-slack-integration-uk'));
const BlogMultiAgentWorkflows = lazy(() => import('../pages/blog/openclaw-multi-agent-workflows'));
const BlogCostOptimisation = lazy(() => import('../pages/blog/openclaw-cost-optimisation-uk'));
const BlogShopifyIntegration = lazy(() => import('../pages/blog/openclaw-shopify-integration-uk'));
const BlogVoiceAgentPhone = lazy(() => import('../pages/blog/openclaw-voice-agent-phone-uk'));
const BlogLeadGenerationCRM = lazy(() => import('../pages/blog/openclaw-lead-generation-crm-uk'));
const BlogEmailAutomation = lazy(() => import('../pages/blog/openclaw-email-automation-uk'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/blog',
    element: <BlogIndex />,
  },
  {
    path: '/blog/deploy-openclaw-uk-clients',
    element: <BlogDeployOpenClaw />,
  },
  {
    path: '/blog/gitwix-openclaw-partnership',
    element: <BlogGitwixPartnership />,
  },
  {
    path: '/blog/openclaw-whatsapp-integration-uk',
    element: <BlogWhatsAppIntegration />,
  },
  {
    path: '/blog/gdpr-compliant-ai-agents-openclaw',
    element: <BlogGDPRCompliant />,
  },
  {
    path: '/blog/openclaw-slack-integration-uk',
    element: <BlogSlackIntegration />,
  },
  {
    path: '/blog/openclaw-multi-agent-workflows',
    element: <BlogMultiAgentWorkflows />,
  },
  {
    path: '/blog/openclaw-cost-optimisation-uk',
    element: <BlogCostOptimisation />,
  },
  {
    path: '/blog/openclaw-shopify-integration-uk',
    element: <BlogShopifyIntegration />,
  },
  {
    path: '/blog/openclaw-voice-agent-phone-uk',
    element: <BlogVoiceAgentPhone />,
  },
  {
    path: '/blog/openclaw-lead-generation-crm-uk',
    element: <BlogLeadGenerationCRM />,
  },
  {
    path: '/blog/openclaw-email-automation-uk',
    element: <BlogEmailAutomation />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/start-your-project',
    element: <InquiryPage />,
  },
  {
    path: '/install',
    element: <InstallPage />,
  },
  {
    path: '/checkout/success',
    element: <CheckoutSuccess />,
  },
  {
    path: '/checkout/cancel',
    element: <CheckoutCancel />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
